import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { DatatablesUtils } from '../_utils/datatables';
import { Contact } from '../_models';

export class HCPs {
  hcps: Contact[];
  extended: any;
  total: number;
}

@Injectable()
export class HcpService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/hcps`);
  }

  listPage(urlParams: any, params: any, dtParams: any): Observable<HCPs> {
    const url = sprintf(this.baseUrl, urlParams);
    const apiParams = DatatablesUtils.convertToApiParams(dtParams);
    return this.http.get<HCPs>(url, {
      params: this.toHttpParams({
        ...params,
        ...apiParams,
      })
    });
  }

  getEvents(id: string, params: any): Observable<any[]> {
    const url = `${environment.apiBaseUrl}/hcps/${id}/events`;
    return this.http.get<any[]>(url, {
      params: this.toHttpParams({
        ...params,
      })
    });
  }

  getLatestEvent(urlParams: any, apiParams?: any): Observable<any> {
    const url = sprintf(`${this.baseUrl}/%(contact_id)s/events/latest`, urlParams);
    return this.http.get<any>(url, {
      params: this.toHttpParams(apiParams)
    });
  }
}
